export const environment = {
  production: true,
  buildId: '2777490133818981',
  configFile: 'config.json',
};
